import { addMonths, format } from "date-fns"
enum PeriodicityEnum {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
}
const getPeriodicity = {
  [PeriodicityEnum.DAY]: "Diário",
  [PeriodicityEnum.WEEK]: "Semanal",
  [PeriodicityEnum.MONTH]: "Mensal",
  [PeriodicityEnum.YEAR]: "Anual",
}
const formatDocument = (value?: string) => {
  if (!value) return ""
  // Remove caracteres especiais, mantendo letras e números
  const cleanValue = value
    .replace(/[^A-Za-z0-9]/g, "")
    .toUpperCase()

  // CPF: apenas números, 11 dígitos
  if (/^\d{11}$/.test(cleanValue)) {
    return cleanValue.replace(
      /(\d{3})(\d{3})(\d{3})(\d{2})/,
      "$1.$2.$3-$4"
    )
  }

  // CNPJ: 14 caracteres (alfanumérico nas posições 1-12, numérico nas posições 13-14)
  if (cleanValue.length === 14) {
    return cleanValue.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    )
  }

  return value
}
const formatPhoneNumber = (value?: string) => {
  return value?.replace(
    /(\d{2})(\d{4,5})(\d{4})/g,
    "($1) $2-$3"
  )
}
const formatMoney = (value?: number) => {
  return value?.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  })
}
const getFromAndToDateMonth = (searchParams: {
  from?: string
  to?: string
}) => {
  const from =
    searchParams.from ??
    format(addMonths(new Date(), -1), "yyyy-MM-dd")
  const to =
    searchParams.to ?? format(new Date(), "yyyy-MM-dd")
  return { from, to }
}
export {
  formatDocument,
  formatMoney,
  formatPhoneNumber,
  getFromAndToDateMonth,
  getPeriodicity,
}
